import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import DashboardCard from './DashboardCard';
import {
  ListRow, RowMain, RowName, RowSub, RowSide,
} from '../styles';
import { EXPENSE_STATUS_COLORS, SEVERITY_COLORS, formatAmount } from '../constants';
import RowAvatar from './RowAvatar';

const StatusChip = styled.span`
  display: inline-block;
  font-size: 11px;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 10px;
  color: #fff;
  background: ${({ $bg }) => $bg};
  white-space: nowrap;
`;

const AmountText = styled.div`
  font-size: 13px;
  font-weight: 800;
  color: ${({ theme }) => theme.colors.text.primary};
  margin-bottom: 3px;
`;

export function initialsOf(name) {
  return (name || '')
    .split(' ')
    .filter(Boolean)
    .map((w) => w[0])
    .slice(0, 2)
    .join('')
    .toLocaleUpperCase('tr-TR');
}

export default function RecentTransactionsCard({ slice }) {
  const { t } = useTranslation();
  const history = useHistory();
  const data = slice.data;
  const items = data?.items || [];

  const statusLabel = (item) => (item.isPolicyViolation
    ? t('expenseDashboard.recent.violation')
    : t(`expense.${item.status}`, { defaultValue: item.status }));

  const statusColor = (item) => (item.isPolicyViolation
    ? SEVERITY_COLORS.critical
    : EXPENSE_STATUS_COLORS[item.status] || '#9e9e9e');

  return (
    <DashboardCard
      cardKey="son-islemler"
      title={t('expenseDashboard.recent.title')}
      meta={data ? t('expenseDashboard.recent.meta', { count: data.todayCount }) : null}
      span={6}
      spanMd={6}
      loading={slice.loading}
      empty={items.length === 0}
      emptyText={t('expenseDashboard.recent.empty')}
    >
      <div>
        {items.map((item) => (
          <ListRow
            key={item.expenseId}
            style={{ cursor: 'pointer' }}
            onClick={() => history.push(`/expenses/${item.expenseId}`)}
          >
            <RowAvatar src={item.profilePicture} name={item.fullName} initials={initialsOf(item.fullName)} />
            <RowMain>
              <RowName>{item.fullName}</RowName>
              <RowSub>{[item.categoryName, item.projectName, item.department, item.location].filter(Boolean).join(' · ')}</RowSub>
            </RowMain>
            <RowSide>
              <AmountText>{formatAmount(item.amount, item.currency)}</AmountText>
              <StatusChip $bg={statusColor(item)}>{statusLabel(item)}</StatusChip>
            </RowSide>
          </ListRow>
        ))}
      </div>
    </DashboardCard>
  );
}
